import { render } from "./MakeSubContract.vue?vue&type=template&id=f8a057ca&scoped=true"
import script from "./MakeSubContract.vue?vue&type=script&lang=js"
export * from "./MakeSubContract.vue?vue&type=script&lang=js"

import "./MakeSubContract.vue?vue&type=style&index=0&id=f8a057ca&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8a057ca"]])

export default __exports__